import moment from "moment";
import React, { useEffect, useState } from 'react';
import {
    Button,
    Card,
    CardBody,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from 'reactstrap';

import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Colxx, Separator } from '../../../../components/common/CustomBootstrap';
import { firestore } from "../../../../helpers/Firebase";
import { sortTimings } from '../../../../helpers/Utils';
import TimingsLogs from './timingsLogs';
const Timings = ({ update, selectedOutlet, defultSettings }) => {
    const [defaultTimings, setDefaultTimings] = useState(false)
    const [loading, setLoading] = useState(false)
    const [showTimingsLogs, setShowTimingsLogs] = useState(false)
    const [isInitialLoad, setIsInitialLoad] = useState(true)

    let optimizedMoment = moment().set('year', 1955).set('month', 0).set('date', 5);
    const [timings, setTimings] = useState(selectedOutlet?.timings || {
        Saturday: { timings: [{ startTime: optimizedMoment.startOf('day').toDate().getTime(), endTime: optimizedMoment.endOf('day').toDate().getTime() }], isOpen: false },
        Sunday: { timings: [{ startTime: optimizedMoment.startOf('day').toDate().getTime(), endTime: optimizedMoment.endOf('day').toDate().getTime() }], isOpen: false },
        Monday: { timings: [{ startTime: optimizedMoment.startOf('day').toDate().getTime(), endTime: optimizedMoment.endOf('day').toDate().getTime() }], isOpen: false },
        Tuesday: { timings: [{ startTime: optimizedMoment.startOf('day').toDate().getTime(), endTime: optimizedMoment.endOf('day').toDate().getTime() }], isOpen: false },
        Wednesday: { timings: [{ startTime: optimizedMoment.startOf('day').toDate().getTime(), endTime: optimizedMoment.endOf('day').toDate().getTime() }], isOpen: false },
        Thursday: { timings: [{ startTime: optimizedMoment.startOf('day').toDate().getTime(), endTime: optimizedMoment.endOf('day').toDate().getTime() }], isOpen: false },
        Friday: { timings: [{ startTime: optimizedMoment.startOf('day').toDate().getTime(), endTime: optimizedMoment.endOf('day').toDate().getTime() }], isOpen: false },
    })
    const CustomInput = React.forwardRef((props, ref) => {
        return (
            <input
                onClick={props.onClick}
                value={props.value}
                type="text"
                className="customDatePicker"
                readOnly={true}
                ref={ref}
            />
        )
    })
    const handleDateChange = (date, selectedDay, index, type) => {
        let editedTimings = JSON.parse(JSON.stringify(timings))
        let optimizedMoment = moment(date).set('year', 1955).set('month', 0).set('date', 5);
        switch (type) {
            case 'start':
                editedTimings[selectedDay].timings[index].startTime = optimizedMoment.toDate().getTime()
                setTimings(editedTimings);
                break;
            case 'end':
                editedTimings[selectedDay].timings[index].endTime = optimizedMoment.toDate().getTime()
                setTimings(editedTimings);
                break;

            default:
                break;
        }
    };

    const handleSwitchChange = (selectedDay, switchState) => {
        let editedTimings = JSON.parse(JSON.stringify(timings))
        editedTimings[selectedDay].isOpen = switchState
        setTimings(editedTimings);
    };

    const addTimings = (day) => {
        let editedTimings = JSON.parse(JSON.stringify(timings))
        let optimizedMoment = moment().set('year', 1955).set('month', 0).set('date', 5);

        editedTimings[day].timings.push({ startTime: optimizedMoment.startOf('day').toDate().getTime(), endTime: optimizedMoment.endOf('day').toDate().getTime() });
        setTimings(editedTimings);
    };

    const removeTimings = (day, timeIndex) => {
        let editedTimings = JSON.parse(JSON.stringify(timings))
        editedTimings[day].timings.splice(timeIndex, 1);

        setTimings(editedTimings);
    };

    const applyForAllTimings = (item) => {
        setTimings({
            Saturday: item,
            Sunday: item,
            Monday: item,
            Tuesday: item,
            Wednesday: item,
            Thursday: item,
            Friday: item,
        })
        setDefaultTimings(false)
        setLoading(false)

    };
    const saveAsDefaultTimings = () => {

        firestore().collection('service_provider').doc(selectedOutlet.sp_id).update({
            [`defultSettings.defultTimings`]:
                timings

        }).then(() => {
            setLoading(false)
            setDefaultTimings(false)
        })

    }

    const fillWithDefaultTimings = () => {
        let { defultTimings } = defultSettings
        setTimings(defultTimings)
        setDefaultTimings(false)
        setLoading(false)

    };

    useEffect(() => {
        // Skip save on initial load
        if (isInitialLoad) {
            setIsInitialLoad(false);
            return;
        }

        update({ timings })
        // eslint-disable-next-line
    }, [timings, isInitialLoad]);

    return (
        <Card className="rounded">
            <CardBody>
                <Row className="survey-app">
                    <Colxx xxs="12">
                        <div className="mb-2">
                            <h1>
                                Timings Schedule
                            </h1>
                            <div className="text-zero top-right-button-container">
                                <Button
                                    color="success"
                                    className="btn-shadow"
                                    size="sm"
                                    onClick={() => setDefaultTimings({ key: 'fillDefault', value: timings })}>Fill with Default Timings
                                </Button>
                                <Button
                                    color="warning"
                                    className="btn-shadow mr-2 ml-2"
                                    size="sm"
                                    onClick={() => setDefaultTimings({ key: 'saveDefault', value: timings })}>Save as Default Timings
                                </Button>
                                <Button
                                    color="primary"
                                    className="btn-shadow"
                                    size="sm"
                                    onClick={() => setShowTimingsLogs(selectedOutlet)}>Show Logs
                                </Button>
                            </div>

                        </div>
                        <Separator className="mb-5" />

                        <Row>
                            <Colxx xxs="12" className="mb-3">
                                {

                                    Object.keys(sortTimings(timings)).map((item, index) => {
                                        return (
                                            <div key={index} className="timingsParent" style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'baseline' }}>
                                                <div className="timingsParent" style={{ flexDirection: 'row', justifyContent: 'flex-start' }}>
                                                    <div className="dayParent">
                                                        <div className="day">{item}</div>
                                                        <Switch
                                                            className="custom-switch custom-switch-primary"
                                                            checked={timings[item].isOpen}
                                                            onChange={switchCheckedPrimary => {
                                                                handleSwitchChange(item, switchCheckedPrimary)
                                                            }}
                                                        />
                                                    </div>
                                                    {
                                                        timings[item].isOpen &&
                                                        <div className="dateContainer">
                                                            {timings[item].timings.map((timing, index2) => {
                                                                return (
                                                                    <div key={index2} className="date2Container" style={{ margin: '0 0 10px 10px' }}>
                                                                        <DatePicker
                                                                            customInput={<CustomInput />}
                                                                            selected={(timing.startTime ? moment(timing.startTime).toDate() : moment().endOf('day').toDate())}
                                                                            className="customDatePicker"
                                                                            showTimeSelectOnly
                                                                            onChange={date => handleDateChange(date, item, index2, 'start')}
                                                                            showTimeSelect
                                                                            dateFormat="hh:mm a"
                                                                            timeFormat="hh:mm a"
                                                                            timeIntervals={30}
                                                                            timeCaption="Time"
                                                                            placeholderText={"Start"}
                                                                            minTime={index2 > 0 ? moment().hours(moment(timings[item].timings[index2 - 1].endTime).hours()).minutes(moment(timings[item].timings[index2 - 1].endTime).minutes()).toDate() : moment().hours(moment().startOf('day').hours()).minutes(moment().startOf('day').minutes()).toDate()}
                                                                            maxTime={moment().hours(moment().endOf('day').hours()).minutes(moment().endOf('day').minutes()).toDate()}
                                                                        />
                                                                        <DatePicker
                                                                            customInput={<CustomInput />}
                                                                            selected={(timing.endTime ? moment(timing.endTime).toDate() : moment().endOf('day').toDate())}
                                                                            className="customDatePicker"
                                                                            showTimeSelectOnly
                                                                            onChange={date => { handleDateChange(date, item, index2, 'end') }}
                                                                            showTimeSelect
                                                                            timeIntervals={30}
                                                                            timeCaption="Time"
                                                                            dateFormat="hh:mm a"
                                                                            timeFormat="hh:mm a"
                                                                            placeholderText={"End"}
                                                                            minTime={timing.startTime ? moment().hours(moment(timing.startTime).hours()).minutes(moment(timing.startTime).minutes()).toDate() : moment().startOf('day').toDate()}
                                                                            maxTime={moment().hours(moment().endOf('day').hours()).minutes(moment().endOf('day').minutes()).toDate()} />
                                                                        {index2 === 0 ? <div className="addTimings" onClick={() => { addTimings(item) }}><i className="simple-icon-plus" /> Add New Timings</div>
                                                                            : <div className="removeTimings" onClick={() => { removeTimings(item, index2) }}><i className="simple-icon-close" /></div>}
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                    }
                                                </div>
                                                {index === 0 &&
                                                    <Button Button
                                                        color='primary '
                                                        size='sm'
                                                        style={{ marginTop: '8px' }}
                                                        onClick={() => {
                                                            setDefaultTimings({ key: 'local', value: timings[item] })
                                                        }}>Apply For All</Button>
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </Colxx>
                        </Row>
                    </Colxx>
                </Row>

                <Modal
                    // size='sm'
                    isOpen={defaultTimings}>
                    <ModalHeader>
                        {defaultTimings.key === 'local' ?
                            'Apply For All Timings' :
                            defaultTimings.key === 'saveDefault' ?
                                'Save Default Timings' :
                                defaultTimings.key === 'fillDefault' ?
                                    'Fill Default Timings' :
                                    ''
                        }
                    </ModalHeader>
                    <ModalBody>
                        {loading && (
                            <div className="loading" />
                        )}
                        {defaultTimings.key === 'local' ?
                            'Are you sure you want to apply for all timings?' :
                            defaultTimings.key === 'saveDefault' ?
                                'Are you sure you want to save to default timings?' :
                                defaultTimings.key === 'fillDefault' ?
                                    'Are you sure you want to fill from default timings?' :
                                    ''
                        }

                    </ModalBody>
                    <ModalFooter>
                        <Button outline color='danger' className='m-1' onClick={() => {
                            setDefaultTimings(false)
                            setLoading(false)
                        }}>Cancel</Button>
                        <Button color='primary ' className='m-1' onClick={() => {
                            setLoading(true)
                            switch (defaultTimings.key) {
                                case 'local':
                                    return applyForAllTimings(defaultTimings?.value);
                                case 'saveDefault':
                                    return saveAsDefaultTimings();
                                case 'fillDefault':
                                    return fillWithDefaultTimings(defaultTimings);
                                default:
                                    break;
                            }
                        }}> {defaultTimings.key === 'local' ?
                            'Apply' :
                            defaultTimings.key === 'saveDefault' ?
                                'Save' :
                                defaultTimings.key === 'fillDefault' ?
                                    'Fill' :
                                    ''
                            }</Button>
                    </ModalFooter>
                </Modal>
                <TimingsLogs washer={showTimingsLogs} dismiss={() => {
                    setShowTimingsLogs(false)
                }} />
            </CardBody>
        </Card>
    );
};



export default Timings;